import { render, staticRenderFns } from "./AcceptTRModal.vue?vue&type=template&id=cfd611f0"
import script from "./acceptTRModal.ts?vue&type=script&lang=ts&external"
export * from "./acceptTRModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd611f0')) {
      api.createRecord('cfd611f0', component.options)
    } else {
      api.reload('cfd611f0', component.options)
    }
    module.hot.accept("./AcceptTRModal.vue?vue&type=template&id=cfd611f0", function () {
      api.rerender('cfd611f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/modal/client/acceptTR/AcceptTRModal.vue"
export default component.exports